// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import SignInPage from './pages/SigninPage';
// import SignupPage from './pages/SignupPage';
// import CostcoStoreView from './pages/CostcoStoreView';
// import DisplayProduct from './pages/DisplayProduct';
// import Checkout from './pages/Checkout';
// import ProductsPage from './pages/ProductsPage';
// import ProtectedRoute from './components/ProtectedRoute'; // Ise import zaroor karein

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* --- 1. PUBLIC ROUTES (Har koi dekh sakta hai) --- */}
//         <Route path="/" element={<HomePage />} />
//         <Route path="/signin" element={<SignInPage />} />
//         <Route path="/signup" element={<SignupPage />} />
        
//         {/* Categories aur Products public rakhein taake log browse kar sakein */}
//         <Route path="/department/:id" element={<CostcoStoreView />} />
//         <Route path="/productswhole/:id" element={<ProductsPage />} />
//         <Route path="/product/:id" element={<DisplayProduct />} />

//         {/* --- 2. SECURE ROUTES (Sirf Login ke baad) --- */}
//         {/* Checkout par jaate hi user se login manga jayega */}
//         <Route 
//           path="/checkout" 
//           element={
//             <ProtectedRoute>
//               <Checkout />
//             </ProtectedRoute>
//           } 
//         />

//         {/* Future mein agar Profile page banayein toh wo bhi yahan aayega:
//         <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} /> 
//         */}

//         {/* --- 3. 404 PAGE (Optional) --- */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// ✅ Match the actual component name





// import React, { useState, useEffect } from 'react';
// import { 
//   Phone, 
//   CheckCircle, 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Facebook, 
//   Instagram, 
//   Linkedin 
// } from 'lucide-react';
// import logo from './assets/mqoelogo.png';
// import tajfront from './assets/tajweedfront.png';
// // Animation library for smooth effects
// import { motion, AnimatePresence } from 'framer-motion';

// const App = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
  
//   // Exact Color Palette from your requirement
//   const BRAND_GREEN = '#28a745'; 
//   const DARK_GREEN = '#147a44';  
//   const BG_CREAM = '#fdf8e1';    
//   const COFFEE_BROWN = '#5d4a3e';

//   // Fonts & Icons loading
//   useEffect(() => {
//     const link = document.createElement('link');
//     link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Montserrat:wght@400;500;600;700&family=Inter:wght@300;400;600;700;800&display=swap';
//     link.rel = 'stylesheet';
//     document.head.appendChild(link);

//     const fontAwesome = document.createElement('link');
//     fontAwesome.rel = 'stylesheet';
//     fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//     document.head.appendChild(fontAwesome);
//   }, []);

//   const serviceOptions = [
//     { name: "Noorani Qaida", link: "#services" },
//     { name: "Tajweed-e-Quran", link: "#services" },
//     { name: "Basic Islamic Educations", link: "#services" }
//   ];

//   // Animation Variants
//   const fadeInUp = {
//     hidden: { opacity: 0, y: 30 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
//   };

//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2
//       }
//     }
//   };

//   return (
//     <div className="min-h-screen text-[#333] overflow-x-hidden" style={{ backgroundColor: BG_CREAM, fontFamily: "'Inter', sans-serif" }}>
//       <style>{`
//         :root {
//             --primary-green: ${BRAND_GREEN};
//             --dark-green: ${DARK_GREEN};
//             --coffee: ${COFFEE_BROWN};
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: all 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//             position: relative;
//         }

//         .nav-link::after {
//             content: '';
//             position: absolute;
//             bottom: -4px;
//             left: 0;
//             width: 0;
//             height: 2px;
//             background: var(--primary-green);
//             transition: width 0.3s;
//         }

//         .nav-link:hover::after {
//             width: 100%;
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 240px;
//             box-shadow: 0 15px 40px rgba(0,0,0,0.12);
//             border-radius: 12px;
//             padding: 12px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(15px);
//             transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
//             border-top: 4px solid var(--primary-green);
//             z-index: 50;
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .glow-effect {
//             position: relative;
//         }

//         .glow-effect::before {
//             content: '';
//             position: absolute;
//             inset: -10px;
//             background: radial-gradient(circle, rgba(40, 167, 69, 0.15) 0%, transparent 70%);
//             border-radius: inherit;
//             z-index: -1;
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .glow-effect:hover::before {
//             opacity: 1;
//         }

//         .floating {
//             animation: float 4s ease-in-out infinite;
//         }

//         @keyframes float {
//             0% { transform: translateY(0px); }
//             50% { transform: translateY(-15px); }
//             100% { transform: translateY(0px); }
//         }

//         .whatsapp-pulse {
//             animation: pulse-green 2s infinite;
//         }

//         @keyframes pulse-green {
//             0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
//             70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
//             100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
//         }

//         ::-webkit-scrollbar {
//             width: 8px;
//         }
//         ::-webkit-scrollbar-track {
//             background: #f1f1f1;
//         }
//         ::-webkit-scrollbar-thumb {
//             background: var(--primary-green);
//             border-radius: 10px;
//         }
//       `}</style>

//       {/* WhatsApp Floating Icon */}
//       <a 
//         href="https://wa.me/923024954689" 
//         target="_blank" 
//         rel="noopener noreferrer"
//         className="fixed bottom-8 right-6 z-[1001] whatsapp-pulse bg-[#25D366] p-4 rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform active:scale-95"
//       >
//         <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.632 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       </a>

//       {/* Header */}
//       <header className="py-4 px-6 lg:px-24 bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-[1000] shadow-sm">
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           <motion.div 
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="flex items-center gap-3"
//           >
//             <div className="flex items-center">
//               {/* Replace with your actual logo img when ready */}
//               <img 
//           src={logo} 
//           alt="Madina Quran Online Education" 
//           className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//         />
//             </div>
//             <span className="text-xl font-extrabold text-[#147a44] hidden lg:block tracking-tight">
//               Madina Quran Online Education
//             </span>
//           </motion.div>
          
//           <nav className="hidden md:flex gap-10">
//             <a href="#" className="nav-link">Home</a>
            
//             <div className="relative group">
//               <div className="nav-link cursor-pointer">
//                 Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//               </div>
//               <div className="dropdown-menu">
//                 {serviceOptions.map((option, idx) => (
//                   <a key={idx} href={option.link} className="block px-6 py-3 text-[15px] font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
//                     {option.name}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             <a href="#contact" className="nav-link">Contact Us</a>
//           </nav>

//           <motion.div 
//             whileTap={{ scale: 0.9 }}
//             className="md:hidden text-2xl cursor-pointer text-green-700" 
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//           >
//             <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//           </motion.div>
//         </div>
//       </header>

//       {/* Mobile Nav */}
//       <AnimatePresence>
//         {isMenuOpen && (
//           <motion.div 
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: 'auto' }}
//             exit={{ opacity: 0, height: 0 }}
//             className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-2xl z-[999] border-t overflow-hidden"
//           >
//             <a href="#" className="nav-link py-3 border-b border-gray-100" onClick={() => setIsMenuOpen(false)}>Home</a>
//             <div className="border-b border-gray-100">
//               <div className="nav-link py-3 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//                 Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//               </div>
//               {isServicesOpen && (
//                 <motion.div 
//                   initial={{ opacity: 0 }} 
//                   animate={{ opacity: 1 }} 
//                   className="pl-4 pb-4 flex flex-col space-y-3 mt-2"
//                 >
//                   {serviceOptions.map((option, idx) => (
//                     <a key={idx} href={option.link} className="text-sm font-medium text-gray-600 hover:text-green-600" onClick={() => setIsMenuOpen(false)}>
//                       {option.name}
//                     </a>
//                   ))}
//                 </motion.div>
//               )}
//             </div>
//             <a href="#contact" className="nav-link py-3" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Main Content Area */}
//       <main className="max-w-6xl mx-auto px-6 lg:px-12 pt-28 pb-12">
//         <motion.h1 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-[40px] md:text-[52px] font-bold text-[#222] mb-12 text-center md:text-left" 
//           style={{ fontFamily: "'Libre Baskerville', serif" }}
//         >
//           Tajweed Quran
//         </motion.h1>

//         {/* Hero Section */}
//         <motion.div 
//           initial={{ opacity: 0, scale: 0.95 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.8 }}
//           className="relative mb-24 rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.15)] border-8 border-white group"
//         >
//           {/* Using a placeholder since local asset isn't available here, but structure is same */}
//           <div className="w-full h-[500px] bg-[#e0f2f1] overflow-hidden">
//              <img 
//                 src={tajfront}
//                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
//                 alt="Students Learning"
//               />
//           </div>
          
//           <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          
//           <motion.div 
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             className="absolute inset-x-0 bottom-12 flex justify-center px-6"
//           >
//              <div 
//                className="text-white py-6 px-10 md:px-16 rounded-2xl text-center text-xl md:text-[34px] font-bold shadow-2xl backdrop-blur-md border border-white/20 floating"
//                style={{ backgroundColor: `${BRAND_GREEN}dd`, fontFamily: "'Montserrat', sans-serif" }}
//              >
//                Online Quran Teaching Tajweed
//              </div>
//           </motion.div>
//         </motion.div>

//         {/* Middle Heading */}
//         <motion.div 
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={fadeInUp}
//           className="text-center mb-20"
//         >
//           <h2 
//             className="text-3xl md:text-[40px] font-bold mb-8 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             🌙 Tajweed Courses – Al Qirat Online Quran Academy
//           </h2>
//           <p className="text-[#555] text-xl leading-[1.8] max-w-4xl mx-auto font-medium opacity-90">
//             Reciting the Quran beautifully starts with correct pronunciation. Our Tajweed courses guide students in Pakistan and worldwide through live one-on-one lessons.
//           </p>
//         </motion.div>

//         {/* Info Grid */}
//         <motion.div 
//           variants={staggerContainer}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           className="grid md:grid-cols-2 gap-10 mb-10"
//         >
//           {/* Card 1 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-lightbulb text-yellow-500"></i> Why Learn Tajweed Online?
//             </h3>
//             <div className="space-y-6 text-[#555] text-[16px] leading-[1.8] font-medium">
//               <p>Flexibility tops the list. Live anywhere in Pakistan and still access expert Tajweed teachers. No travel, no fixed hours. Sessions fit your calendar.</p>
//               <p>Personal attention drives results. One teacher, one student, means every mistake gets fixed instantly. Beginners start with basic makharij, advanced readers polish rules.</p>
//               <p>Interactive tools make learning stick. Teachers share screens to highlight rules, recordings let you replay tricky spots. Parents see results within months.</p>
//             </div>
//           </motion.div>

//           {/* Card 2 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-book-open text-blue-500"></i> What is Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] mb-8 leading-[1.8] font-medium">
//               Tajweed means beautifying recitation through rules. It covers articulation points, elongation, and nasal sounds. The Prophet Muhammad (PBUH) recited with perfect rhythm.
//             </p>
//             <ul className="space-y-5">
//               {[
//                 { t: 'Makharij', d: 'articulation points of letters' },
//                 { t: 'Harakat', d: 'short vowels Fatha, Kasra, Damma' },
//                 { t: 'Madd', d: 'elongation of sounds' },
//                 { t: 'Ghunnah', d: 'nasal hums for Noon & Meem' },
//                 { t: 'Qalqalah', d: 'bouncing of stopped letters' },
//               ].map((item, idx) => (
//                 <motion.li 
//                   key={item.t} 
//                   initial={{ x: -10, opacity: 0 }}
//                   whileInView={{ x: 0, opacity: 1 }}
//                   transition={{ delay: idx * 0.1 }}
//                   className="flex items-start gap-4 p-3 rounded-xl hover:bg-green-50 transition-colors"
//                 >
//                   <CheckCircle size={22} className="shrink-0 text-green-500" strokeWidth={3} />
//                   <span className="text-[16px]">
//                     <span className="font-bold text-[#333]">{item.t}</span> — <span className="text-[#555] font-medium">{item.d}</span>
//                   </span>
//                 </motion.li>
//               ))}
//             </ul>
//           </motion.div>
//         </motion.div>

//         {/* Row 2 Grid */}
//         <div className="grid md:grid-cols-2 gap-10 mb-10">
//           <motion.div 
//             initial={{ opacity: 0, x: -30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               How Tajweed Enhances Recitation
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] mb-6 font-medium">
//               Tajweed shapes every letter leaving the tongue, stretching vowels, and pausing exactly where intended. Teachers demonstrate live, practice immediately, and within weeks recitations flow smoothly.
//             </p>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Family prayers gain harmony. Children lead prayers without stumbling; adults feel rhythm in their chest, and listeners are moved by the beauty.
//             </p>
//           </motion.div>

//           <motion.div 
//             initial={{ opacity: 0, x: 30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               Who Should Learn Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Beginners, housewives, working adults, teens, retirees, and Hifz students. Kids from age 7 join with easy-to-follow rules. Adults refine rusty recitations. Everyone learns at their own pace in a comfortable environment.
//             </p>
//             <div className="mt-8 grid grid-cols-2 gap-4">
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">7+</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Min Age</div>
//                </div>
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">1-on-1</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Lessons</div>
//                </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* Contact Block */}
//         <motion.div 
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.06)] border border-gray-100 max-w-3xl mx-auto overflow-hidden relative"
//         >
//           <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full"></div>
          
//           <h3 
//             className="text-[28px] md:text-[32px] font-bold mb-6 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             Contact Al Qirat Online Quran Academy
//           </h3>
//           <p className="text-[#555] text-[17px] leading-[1.8] mb-8 font-medium">
//             Phone calls connect you directly to our team for schedules and course inquiries. WhatsApp is available for quick messages. Responses are fast even at odd hours.
//           </p>
//           <div className="mb-10 p-6 bg-gray-50 rounded-2xl border-l-4 border-green-500">
//             <p className="text-[17px] font-bold text-[#333] flex items-center gap-3">
//                <Phone size={20} className="text-green-600" />
//                Phone: <span className="text-[#333] font-medium">+92 315 5141289</span>
//             </p>
//           </div>
//           <motion.button 
//             whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(40, 167, 69, 0.3)" }}
//             whileTap={{ scale: 0.98 }}
//             className="w-full md:w-auto text-white px-12 py-5 rounded-2xl font-bold text-[18px] tracking-wide transition-all shadow-xl bg-gradient-to-r from-[#28a745] to-[#147a44]"
//           >
//             Book Free Trial / Contact Us
//           </motion.button>
//         </motion.div>
//       </main>

//       {/* Footer */}
//       <footer className="bg-white border-t border-gray-100 mt-24">
//         <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 grid md:grid-cols-3 gap-16 lg:gap-24">
//           <div className="space-y-8">
//             <div className="flex items-center gap-3">
//                <div className="w-10 h-10 bg-green-600 rotate-45 flex items-center justify-center rounded-lg shadow-lg">
//                   <span className="rotate-[-45deg] text-[10px] font-black text-white">ALQ</span>
//                </div>
//                <span className="text-2xl font-black tracking-tighter" style={{ color: BRAND_GREEN }}>AL QIRAT</span>
//             </div>
//             <p className="text-[#888] text-[15px] leading-[1.9] font-medium">
//               Online Quran teaching Pakistan offers modern teaching methods for all non-Arabic speakers Muslims who want to learn Arabic, & Quran Islamic studies.
//             </p>
//           </div>

//           <div className="grid grid-cols-2 gap-8">
//             <div>
//               <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Useful Links</h4>
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">About Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Feature</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Services</a></li>
//               </ul>
//             </div>
//             <div className="pt-[52px]">
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Blog</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Contact Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Fees</a></li>
//               </ul>
//             </div>
//           </div>

//           <div>
//             <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Follow Us</h4>
//             <p className="text-[#888] text-[15px] mb-8 font-medium">Don't miss our future updates! Get Subscribed Today!</p>
//             <div className="flex gap-4">
//               {[Facebook, Instagram, Linkedin].map((Icon, i) => (
//                 <motion.a 
//                   key={i} 
//                   whileHover={{ y: -5, backgroundColor: BRAND_GREEN, color: '#fff', borderColor: BRAND_GREEN }}
//                   href="#" 
//                   className="w-12 h-12 border border-gray-200 rounded-2xl flex items-center justify-center text-[#999] transition-all bg-white"
//                 >
//                   <Icon size={22} />
//                 </motion.a>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="bg-[#5d4a3e] py-8 text-center relative overflow-hidden">
//           <div className="absolute inset-0 bg-white/5 opacity-10"></div>
//           <p className="text-white text-[13px] font-bold tracking-widest relative z-10 opacity-90">
//             © 2022-2025 AL QIRAT ONLINE ACADEMY. ALL RIGHTS RESERVED
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default App;

// import React, { useState, useEffect,useRef } from 'react';
// import logo from './assets/mqoelogo.png';

// const AnimatedCounter = ({ end, duration = 2000 }) => {
//   const [count, setCount] = useState(0);
//   const countRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (countRef.current) {
//       observer.observe(countRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   useEffect(() => {
//     if (!isVisible) return;

//     let start = 0;
//     const increment = end / (duration / 16);
//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [isVisible, end, duration]);

//   return <span ref={countRef}>{count.toLocaleString()}</span>;
// };

// // Main App Component
// const App = () => {
//    const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [userName, setUserName] = useState('');

//   useEffect(() => {
//     const link = document.createElement('link');
//     link.rel = 'stylesheet';
//     link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//     document.head.appendChild(link);
//   }, []);

//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const name = e.target.elements.name.value;
//     setUserName(name);
//     setFormSubmitted(true);
//   };

//   const serviceOptions = [
//     { name: "Noorani Qaida", link: "#services" },
//     { name: "Tajweed-e-Quran", link: "#services" },
//     { name: "Basic Islamic Educations", link: "#services" }
//   ];

//   return (
//     <div className="font-['Inter'] text-[#1a3a2a] bg-white pt-20 overflow-x-hidden scroll-smooth">
//       {/* CSS Styles injected via Template Literal to maintain exactness */}
//     <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&display=swap');
        
//         :root {
//             --primary-green: #147a44;
//             --submit-brown: #634d3a;
//             --accent-lime: #a6ff00;
//         }

//         body {
//             font-family: 'Inter', sans-serif;
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: color 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//         }

//         .nav-link:hover {
//             color: var(--primary-green);
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 220px;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             padding: 10px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(10px);
//             transition: all 0.3s ease;
//             border-top: 3px solid var(--primary-green);
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .dropdown-item {
//             padding: 10px 20px;
//             display: block;
//             color: #1a3a2a;
//             font-weight: 500;
//             transition: all 0.2s;
//         }

//         .dropdown-item:hover {
//             background-color: #f4fbf7;
//             color: var(--primary-green);
//             padding-left: 25px;
//         }

//         .green-pill {
//             background-color: #e9f5ee;
//             color: var(--primary-green);
//             padding: 8px 16px;
//             border-radius: 25px;
//             font-size: 14px;
//             font-weight: 600;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//         }

//         .course-card {
//             background: white;
//             border-radius: 20px;
//             padding: 40px 30px;
//             text-align: center;
//             box-shadow: 0 10px 30px rgba(0,0,0,0.05);
//             transition: transform 0.3s ease;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//             justify-content: space-between;
//         }

//         .course-card:hover {
//             transform: translateY(-10px);
//         }

//         .stat-card {
//             background: rgba(255, 255, 255, 0.1);
//             backdrop-filter: blur(12px);
//             padding: 40px 20px;
//             border-radius: 24px;
//             text-align: center;
//             color: white;
//             border: 1px solid rgba(255, 255, 255, 0.2);
//             transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//             position: relative;
//             overflow: hidden;
//             box-shadow: 0 15px 35px rgba(0,0,0,0.2);
//             transform-style: preserve-3d;
//             perspective: 1000px;
//         }

//         .stat-card:hover {
//             transform: translateY(-10px) rotateX(5deg) rotateY(5deg);
//             border-color: var(--accent-lime);
//             box-shadow: 0 25px 50px rgba(0,0,0,0.3), 0 0 20px rgba(166, 255, 0, 0.2);
//         }

//         .stat-card::before {
//             content: '';
//             position: absolute;
//             top: -50%;
//             left: -50%;
//             width: 200%;
//             height: 200%;
//             background: radial-gradient(circle, rgba(166, 255, 0, 0.1) 0%, transparent 70%);
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .stat-card:hover::before {
//             opacity: 1;
//         }

//         .form-input {
//             width: 100%;
//             border: 1px solid #ced4da;
//             padding: 15px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//             outline: none;
//             transition: border-color 0.3s;
//         }

//         .form-input:focus {
//             border-color: var(--primary-green);
//         }

//         .btn-submit {
//             background-color: var(--submit-brown);
//             color: white;
//             width: 100%;
//             padding: 15px;
//             border-radius: 4px;
//             font-weight: 700;
//             text-transform: capitalize;
//             font-size: 18px;
//             transition: opacity 0.3s;
//             cursor: pointer;
//         }

//         .btn-submit:hover {
//             opacity: 0.9;
//         }

//         .whatsapp-float {
//             position: fixed;
//             bottom: 30px;
//             right: 30px;
//             background-color: #25d366;
//             color: white;
//             width: 60px;
//             height: 60px;
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-size: 30px;
//             box-shadow: 2px 5px 15px rgba(0,0,0,0.3);
//             z-index: 1000;
//             transition: transform 0.3s;
//         }

//         .whatsapp-float:hover {
//             transform: scale(1.1);
//         }

//         .stats-bg-glow {
//             position: absolute;
//             width: 300px;
//             height: 300px;
//             background: var(--accent-lime);
//             filter: blur(150px);
//             opacity: 0.15;
//             border-radius: 50%;
//             pointer-events: none;
//         }
//       `}</style>

//       {/* WhatsApp Button */}
//        <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer" className="whatsapp-float">
//         <i className="fab fa-whatsapp"></i>
//       </a>

//           {/* Header */}
//      <header className="py-4 px-6 lg:px-24 bg-white fixed top-0 left-0 right-0 z-[1000] shadow-md">
//   <div className="max-w-7xl mx-auto flex justify-between items-center">
//     <div className="flex items-center gap-3">
//       {/* Logo Section */}
//       <div className="flex items-center">
//         <img 
//           src={logo} 
//           alt="Madina Quran Online Education" 
//           className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//         />
//       </div>
      
//       {/* Brand Name */}
//       <span className="text-xl font-extrabold text-[#147a44] hidden lg:block">
//         Madina Quran Online Education
//       </span>
//     </div>
    
//     <nav className="hidden md:flex gap-10">
//       <a href="#" className="nav-link">Home</a>
      
//       {/* Desktop Dropdown */}
//       <div className="relative group">
//         <div className="nav-link cursor-pointer">
//           Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//         </div>
//         <div className="dropdown-menu">
//           {serviceOptions.map((option, idx) => (
//             <a key={idx} href={option.link} className="dropdown-item">{option.name}</a>
//           ))}
//         </div>
//       </div>

//       <a href="#contact" className="nav-link">Contact Us</a>
//     </nav>

//     <div className="md:hidden text-2xl cursor-pointer" onClick={toggleMenu}>
//       <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//     </div>
//   </div>
// </header>

//       {/* Mobile Nav */}
//       {isMenuOpen && (
//         <div className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-xl z-[999] border-t max-h-[80vh] overflow-y-auto">
//           <a href="#" className="nav-link py-2 border-b" onClick={toggleMenu}>Home</a>
          
//           {/* Mobile Dropdown Toggle */}
//           <div className="border-b">
//             <div className="nav-link py-2 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//               Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//             </div>
//             {isServicesOpen && (
//               <div className="pl-4 pb-2 bg-gray-50 flex flex-col">
//                 {serviceOptions.map((option, idx) => (
//                   <a key={idx} href={option.link} className="py-2 text-sm font-medium text-gray-600" onClick={toggleMenu}>{option.name}</a>
//                 ))}
//               </div>
//             )}
//           </div>
          
//           <a href="#contact" className="nav-link py-2" onClick={toggleMenu}>Contact Us</a>
//         </div>
//       )}

//       {/* Hero Section */}
//       <section className="bg-[#f4fbf7] py-16 px-6 lg:px-24">
//         <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h1 className="text-4xl lg:text-6xl font-extrabold text-[#147a44] leading-tight mb-6">
//               Online Quran Teaching With Expert Tutors
//             </h1>
//             <p className="text-lg text-gray-700 mb-8 leading-relaxed">
//               Madina Quran Online Education offers professional online Quran teaching for kids and adults worldwide. Learn the Holy Quran with Tajweed through one-to-one live classes with qualified male and female teachers.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
//               <div className="green-pill"><i className="fas fa-check-circle"></i> One-to-One Quran Classes</div>
//               <div className="green-pill"><i className="fas fa-check-circle"></i> Certified Male & Female Tutors</div>
//               <div className="green-pill"><i className="fas fa-check-circle"></i> Flexible Class Timings</div>
//             </div>
//             <a href="#contact" className="inline-block bg-[#147a44] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#0d5e34] transition shadow-lg">Get Started Now</a>
//           </div>
//           <div className="relative">
//             <img src="https://images.unsplash.com/photo-1585036156171-384164a8c675" alt="Holy Quran" className="rounded-3xl shadow-2xl w-full object-cover" />
//           </div>
//         </div>
//       </section>

//       {/* Stats Section with Animations and Glow */}
//       <section className="bg-[#147a44] py-24 px-6 relative overflow-hidden">
//         {/* Background Glowing Effects */}
//         <div className="stats-bg-glow -top-20 -left-20"></div>
//         <div className="stats-bg-glow -bottom-20 -right-20"></div>

//         <div className="max-w-7xl mx-auto text-center mb-16 relative z-10">
//           <h2 className="text-4xl font-bold text-white mb-4">Trusted Online Quran Teaching Academy Worldwide</h2>
//           <p className="text-green-100 opacity-90 text-lg">Thousands of students trust our academy for professional Quran learning.</p>
//         </div>

//         <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={5000} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Students</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={20} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Countries</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={100} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Expert Tutors</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={10} />
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Years Experience</div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section id="services" className="bg-[#f4fbf7] py-20 px-6">
//         <div className="max-w-7xl mx-auto text-center mb-16">
//           <h2 className="text-4xl font-bold mb-4 text-[#147a44]">Our Online Quran Courses</h2>
//           <p className="text-gray-600 max-w-3xl mx-auto">At Madina Quran Online Education, we offer specialized courses for kids and adults designed to make learning easy and effective.</p>
//         </div>
//         <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">📖</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Noorani Qaida Course</h3>
//               <p className="text-gray-600 mb-8">Basic Quran reading skills and Arabic letter pronunciation for beginners. Ideal for kids starting their journey.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">🕌</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Quran with Tajweed</h3>
//               <p className="text-gray-600 mb-8">Learn to recite the Holy Quran correctly with proper Tajweed rules and beautiful pronunciation.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">⭐</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Islamic Education</h3>
//               <p className="text-gray-600 mb-8">Strengthen your spiritual foundation through our comprehensive Islamic studies and Hifz program, featuring expert guidance and personalized daily tracking.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section id="contact" className="py-20 px-6 bg-white">
//         <div className="max-w-3xl mx-auto text-center mb-10">
//           <h2 className="text-3xl font-bold text-[#147a44]">Contact Us / Register</h2>
//           <p className="text-gray-500 mt-2">Fill the form below and we'll get back to you shortly to schedule your trial class.</p>
//         </div>
//         <div className="max-w-xl mx-auto">
//           {!formSubmitted ? (
//             <form className="space-y-4" onSubmit={handleSubmit}>
//               <input type="text" name="name" className="form-input" placeholder="Your Name" required />
//               <input type="tel" name="phone" className="form-input" placeholder="Phone (e.g. +1...)" required />
//               <input type="email" name="email" className="form-input" placeholder="Email Address" required />
//               <textarea name="message" className="form-input h-32" placeholder="Your Message or Chosen Course"></textarea>
//               <button type="submit" className="btn-submit">SUBMIT APPLICATION</button>
//             </form>
//           ) : (
//             <div className="text-center p-10 bg-green-50 rounded-lg">
//               <i className="fas fa-check-circle text-5xl text-[#147a44] mb-4"></i>
//               <h3 className="text-2xl font-bold text-[#147a44] mb-2">Thank You, {userName}!</h3>
//               <p className="text-gray-600">Your application has been received. Our team will contact you within 24 hours.</p>
//               <button onClick={() => setFormSubmitted(false)} className="mt-4 text-[#147a44] underline font-bold">Send another message</button>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-50 border-t border-gray-100 py-12 px-6">
//         <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 mb-8 text-left">
//           <div>
//             <div className="flex items-center gap-2 mb-4">
//               <div className="w-8 h-8 bg-[#147a44] rounded-full flex items-center justify-center text-white font-bold text-xs">MQOE</div>
//               <span className="text-lg font-extrabold text-[#147a44]">Madina Quran Online Education</span>
//             </div>
//             <p className="text-gray-500 text-sm">Professional Online Quran Academy providing quality education worldwide for over a decade.</p>
//           </div>
//           <div>
//             <h4 className="font-bold text-[#147a44] mb-4">Quick Links</h4>
//             <ul className="text-gray-500 text-sm space-y-2">
//               <li><a href="#" className="hover:text-[#147a44]">Home</a></li>
//               <li><a href="#services" className="hover:text-[#147a44]">Services</a></li>
//               <li><a href="#contact" className="hover:text-[#147a44]">Register Now</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-bold text-[#147a44] mb-4">Support</h4>
//             <ul className="text-gray-500 text-sm space-y-2">
//               <li><i className="fas fa-envelope mr-2"></i> madinaquranonlineeducation@gmail.com</li>
//               <li><i className="fas fa-phone mr-2"></i> +92 315 5141289</li>
//             </ul>
//           </div>
//         </div>
//         <div className="border-t border-gray-200 pt-8 text-center text-gray-400 text-xs">
//           <p>&copy; 2024 Madina Quran Online Education. All Rights Reserved.</p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default App;



import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './QHome'; // Jahan aapne home rakha hai
import TajweedPage from './Tajweed'; // Jahan aapne tajweed rakha hai
import All from './All';
import Noorani from './Noorani.jsx';
function App() {
  return (
    <Router>
      <Routes>
        {/* '/' ka matlab hai jab site khule to Home dikhay */}
        <Route path="/" element={<HomePage />} />
        
        {/* '/tajweed' par aapka doosra page khulega */}
        <Route path="/tajweed" element={<TajweedPage />} />


        <Route path="/all" element={<All />} />

        <Route path="/noorani" element={<Noorani />} />
      </Routes>
    </Router>
  );
}

export default App;




// import TigersCommunication from './pages/tc';

// function App() {
//   return <TigersCommunication />;
// }
// export default App;

// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { 
//   Heart, 
//   Smile, 
//   Star, 
//   Camera, 
//   Phone, 
//   MapPin, 
//   Menu, 
//   X,
//   Palette,
//   Baby,
//   Cloud,
//   Sun,
//   Music,
//   Sparkles
// } from 'lucide-react';

// /**
//  * --- CUSTOM RAINBOW ICON ---
//  * Fixed: Using a simple SVG to avoid any Lucide export errors.
//  */
// const RainbowIcon = ({ className }) => (
//   <svg 
//     viewBox="0 0 24 24" 
//     fill="none" 
//     stroke="currentColor" 
//     strokeWidth="2.5" 
//     strokeLinecap="round" 
//     strokeLinejoin="round" 
//     className={className}
//   >
//     <path d="M6 18a6 6 0 0 1 12 0" stroke="#FF6B6B" />
//     <path d="M4 18a8 8 0 0 1 16 0" stroke="#FFD93D" />
//     <path d="M2 18a10 10 0 0 1 20 0" stroke="#6BCB77" />
//   </svg>
// );

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-lg py-2' : 'bg-transparent py-5'}`}>
//       <div className="container mx-auto px-6 flex justify-between items-center">
//         <motion.div 
//           whileHover={{ scale: 1.1, rotate: -2 }}
//           className="flex items-center gap-2 cursor-pointer"
//         >
//           <div className="bg-gradient-to-tr from-pink-400 via-yellow-400 to-blue-400 p-2 rounded-full shadow-lg">
//             <RainbowIcon className="w-6 h-6 text-white" />
//           </div>
//           <span className="text-2xl font-black bg-gradient-to-r from-pink-500 via-purple-500 via-blue-500 to-green-500 bg-clip-text text-transparent tracking-tight">
//             Little Aurora
//           </span>
//         </motion.div>

//         <div className="hidden md:flex gap-8 items-center">
//           {['Home', 'About', 'Programs', 'Gallery'].map((item) => (
//             <a key={item} href={`#${item.toLowerCase()}`} className="font-black text-gray-600 hover:text-pink-500 transition-colors text-sm uppercase tracking-tighter">
//               {item}
//             </a>
//           ))}
//           <button className="bg-gradient-to-r from-pink-400 to-orange-400 text-white px-6 py-2 rounded-full font-black text-sm shadow-md hover:shadow-xl transition-all">
//             Contact Us
//           </button>
//         </div>

//         <button className="md:hidden text-gray-700" onClick={() => setIsOpen(!isOpen)}>
//           {isOpen ? <X /> : <Menu />}
//         </button>
//       </div>

//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: 'auto' }}
//             exit={{ opacity: 0, height: 0 }}
//             className="md:hidden bg-white border-t border-gray-100 overflow-hidden shadow-2xl"
//           >
//             {['Home', 'About', 'Programs', 'Gallery', 'Contact'].map((item) => (
//               <a key={item} href={`#${item.toLowerCase()}`} className="block px-8 py-4 text-gray-700 font-black border-b border-gray-50 text-center uppercase tracking-tighter" onClick={() => setIsOpen(false)}>
//                 {item}
//               </a>
//             ))}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </nav>
//   );
// };

// const Hero = () => (
//   <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#FFFDF5]">
//     {/* Rainbow Background Blobs */}
//     <div className="absolute -top-20 -left-20 w-[400px] h-[400px] bg-pink-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob"></div>
//     <div className="absolute top-40 right-0 w-[400px] h-[400px] bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob animation-delay-2000"></div>
//     <div className="absolute -bottom-20 left-1/2 w-[400px] h-[400px] bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-blob animation-delay-4000"></div>

//     <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center relative z-10">
//       <motion.div
//         initial={{ opacity: 0, y: 30 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.8 }}
//       >
//         <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm border border-pink-100 mb-6">
//           <Sparkles className="text-yellow-400 w-4 h-4 animate-spin" />
//           <span className="text-xs font-black text-pink-500 uppercase tracking-widest">Canada's Most Colorful Daycare</span>
//         </div>
//         <h1 className="text-6xl md:text-8xl font-black text-gray-900 leading-[0.85] tracking-tighter mb-6">
//           A World of <br />
//           <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-orange-400 via-yellow-400 via-green-400 via-blue-500 to-purple-500 animate-gradient-x">
//             Happy Colors
//           </span>
//         </h1>
//         <p className="text-xl text-gray-600 max-w-lg leading-relaxed mb-10 font-medium">
//           At Little Aurora Kids, we fill every child's life with the colors of the rainbow. Play, laughter, and endless fun!
//         </p>
//         <div className="flex flex-wrap gap-4">
//           <motion.button 
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//             className="bg-pink-500 text-white px-10 py-5 rounded-[30px] font-black shadow-lg shadow-pink-200 flex items-center gap-2"
//           >
//             Start Playing <Heart fill="white" size={20} />
//           </motion.button>
//           <motion.button 
//              whileHover={{ scale: 1.05 }}
//             className="bg-white border-4 border-yellow-300 text-gray-800 px-10 py-5 rounded-[30px] font-black shadow-lg"
//           >
//             Our Gallery
//           </motion.button>
//         </div>
//       </motion.div>

//       <div className="relative">
//         <motion.div
//           animate={{ y: [0, -20, 0] }}
//           transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//           className="relative z-10"
//         >
//           <div className="relative bg-white p-4 rounded-[60px] shadow-2xl rotate-3 border-8 border-white group">
//             <img 
//               src="https://images.unsplash.com/photo-1566453838084-7ec27e71b3ca?q=80&w=800&auto=format&fit=crop" 
//               alt="Kids playing together" 
//               className="rounded-[50px] w-full aspect-square object-cover"
//             />
//             <div className="absolute -top-8 -right-8 bg-yellow-400 p-4 rounded-2xl shadow-xl animate-bounce">
//               <Sun className="text-white" size={32} />
//             </div>
//             <div className="absolute -bottom-8 -left-8 bg-blue-400 p-4 rounded-2xl shadow-xl animate-pulse">
//               <Cloud className="text-white" size={32} />
//             </div>
//           </div>
//         </motion.div>
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border-[40px] border-pink-50 rounded-full opacity-50 -z-10"></div>
//       </div>
//     </div>
//   </section>
// );

// const Features = () => {
//   const cards = [
//     { title: 'Morning Music', icon: Music, color: 'from-pink-100 to-pink-200', text: 'text-pink-600', desc: 'Starting the day with joyful songs and dancing.' },
//     { title: 'Art & Crafts', icon: Palette, color: 'from-yellow-100 to-yellow-200', text: 'text-yellow-700', desc: "Coloring every child's creativity and imagination." },
//     { title: 'Healthy Bites', icon: Smile, color: 'from-green-100 to-green-200', text: 'text-green-700', desc: 'Fresh, organic, and nutritious meals every day.' },
//     { title: 'Safe Sleep', icon: Baby, color: 'from-blue-100 to-blue-200', text: 'text-blue-600', desc: 'Peaceful naps in a cozy, home-like environment.' },
//   ];

//   return (
//     <section id="programs" className="py-24 bg-white">
//       <div className="container mx-auto px-6">
//         <div className="text-center mb-20">
//           <h2 className="text-5xl font-black text-gray-900 mb-4">Why We're Special</h2>
//           <div className="w-40 h-3 bg-gradient-to-r from-pink-400 via-yellow-400 to-blue-400 mx-auto rounded-full"></div>
//         </div>

//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
//           {cards.map((card, i) => (
//             <motion.div
//               key={i}
//               whileHover={{ y: -20, rotate: i % 2 === 0 ? 2 : -2 }}
//               className={`p-10 rounded-[50px] bg-gradient-to-br ${card.color} shadow-sm border-4 border-white`}
//             >
//               <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center mb-6 shadow-md">
//                 <card.icon className={card.text} size={30} />
//               </div>
//               <h3 className={`text-2xl font-black mb-4 ${card.text}`}>{card.title}</h3>
//               <p className="text-gray-600 font-bold text-sm leading-relaxed">{card.desc}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// const Gallery = () => (
//   <section id="gallery" className="py-24 bg-pink-50/30">
//     <div className="container mx-auto px-6">
//       <div className="flex flex-col md:flex-row justify-between items-center mb-16 gap-4">
//         <h2 className="text-5xl font-black text-gray-900">Sweet Moments</h2>
//         <button className="bg-white px-8 py-3 rounded-full font-black text-pink-500 shadow-md border-2 border-pink-100 hover:bg-pink-500 hover:text-white transition-all">See All Photos</button>
//       </div>

//       <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//         {[
//           "https://images.unsplash.com/photo-1502086223501-7ea24ec394e0?q=80&w=400&h=400&auto=format&fit=crop",
//           "https://images.unsplash.com/photo-1516627145497-ae6968895b74?q=80&w=400&h=400&auto=format&fit=crop",
//           "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?q=80&w=400&h=400&auto=format&fit=crop",
//           "https://images.unsplash.com/photo-1485546246426-74dc88dec4d9?q=80&w=400&h=400&auto=format&fit=crop"
//         ].map((url, i) => (
//           <motion.div 
//             key={i} 
//             whileHover={{ scale: 1.05 }}
//             className="aspect-square bg-white p-3 rounded-[40px] shadow-xl overflow-hidden group cursor-pointer"
//           >
//             <div className="w-full h-full rounded-[30px] overflow-hidden">
//               <img 
//                 src={url} 
//                 alt="Happy child moments" 
//                 className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//               />
//             </div>
//           </motion.div>
//         ))}
//       </div>
//     </div>
//   </section>
// );

// const Contact = () => (
//   <section id="contact" className="py-24 bg-white relative">
//     <div className="container mx-auto px-6">
//       <div className="bg-gradient-to-br from-blue-500 to-purple-600 rounded-[80px] p-12 md:p-24 relative overflow-hidden text-white shadow-2xl">
//         <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
        
//         <div className="grid lg:grid-cols-2 gap-16 relative z-10 items-center">
//           <div>
//             <h2 className="text-5xl md:text-7xl font-black mb-8 leading-tight">Let's Connect!</h2>
//             <p className="text-xl text-blue-100 mb-12">Come and be a part of our colorful world. Send us a message today!</p>
            
//             <div className="space-y-6">
//               <div className="flex items-center gap-4">
//                 <div className="bg-white/20 p-3 rounded-2xl"><Phone /></div>
//                 <div>
//                   <p className="text-xs font-black uppercase tracking-widest text-blue-200">Phone</p>
//                   <p className="text-2xl font-bold">+1 (403) 555-RAIN</p>
//                 </div>
//               </div>
//               <div className="flex items-center gap-4">
//                 <div className="bg-white/20 p-3 rounded-2xl"><MapPin /></div>
//                 <div>
//                   <p className="text-xs font-black uppercase tracking-widest text-blue-200">Location</p>
//                   <p className="text-2xl font-bold">Calgary, AB, Canada</p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="bg-white p-10 rounded-[50px] text-gray-900 shadow-2xl">
//             <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
//               <input type="text" placeholder="Your Name" className="w-full bg-gray-100 border-none px-6 py-4 rounded-2xl focus:ring-4 focus:ring-blue-100 font-bold shadow-inner" />
//               <input type="tel" placeholder="Phone Number" className="w-full bg-gray-100 border-none px-6 py-4 rounded-2xl focus:ring-4 focus:ring-blue-100 font-bold shadow-inner" />
//               <textarea placeholder="Your Message..." rows="3" className="w-full bg-gray-100 border-none px-6 py-4 rounded-2xl focus:ring-4 focus:ring-blue-100 font-bold shadow-inner"></textarea>
//               <button className="w-full bg-gradient-to-r from-pink-500 to-orange-400 text-white font-black py-5 rounded-2xl shadow-lg uppercase tracking-widest hover:scale-105 transition-transform duration-300">
//                 Send Love!
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// export default function App() {
//   return (
//     <div className="font-sans selection:bg-pink-200 selection:text-pink-900 overflow-x-hidden">
//       <Navbar />
//       <Hero />
//       <Features />
//       <Gallery />
//       <Contact />

//       <footer className="py-12 bg-gray-50 text-center">
//         <div className="flex justify-center items-center gap-2 mb-4">
//           <div className="bg-pink-500 p-1.5 rounded-full shadow-md">
//             <RainbowIcon className="text-white w-4 h-4" />
//           </div>
//           <span className="text-xl font-black text-gray-800 tracking-tighter">Little Aurora Kids</span>
//         </div>
//         <p className="text-gray-400 text-xs font-black uppercase tracking-widest italic">Made with Rainbows and Love 🌈</p>
//         <div className="mt-4 text-[10px] text-gray-300 font-bold uppercase tracking-widest">Calgary, Alberta • Premium Daycare</div>
//       </footer>

//       {/* Global Styles including fonts and custom animations */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');
        
//         body {
//           font-family: 'Plus Jakarta Sans', sans-serif;
//           scroll-behavior: smooth;
//           margin: 0;
//           padding: 0;
//         }

//         @keyframes blob {
//           0% { transform: translate(0px, 0px) scale(1); }
//           33% { transform: translate(30px, -50px) scale(1.1); }
//           66% { transform: translate(-20px, 20px) scale(0.9); }
//           100% { transform: translate(0px, 0px) scale(1); }
//         }
//         .animate-blob {
//           animation: blob 7s infinite;
//         }
//         .animation-delay-2000 { animation-delay: 2s; }
//         .animation-delay-4000 { animation-delay: 4s; }

//         .animate-gradient-x {
//           background-size: 200% 200%;
//           animation: gradient-x 15s ease infinite;
//         }
//         @keyframes gradient-x {
//           0% { background-position: 0% 50%; }
//           50% { background-position: 100% 50%; }
//           100% { background-position: 0% 50%; }
//         }
//       `}</style>
//     </div>
//   );
// }

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import SignInPage from './pages/SigninPage';
// import SignupPage from './pages/SignupPage';
// import CostcoStoreView from './pages/CostcoStoreView';
// import AdminDashboard from './pages/AdminDashboard';
// function App() {
//   return (
//     <AdminDashboard></AdminDashboard>
//   );
// }

// export default App;